// Navigation tracking utility for breadcrumb generation

const MAX_HISTORY_LENGTH = 10;

export const NavigationTracker = {
  // Add a navigation entry to history
  addNavigation(from, additionalData = {}) {
    try {
      const history = this.getNavigationHistory();
      
      const navigationEntry = {
        from,
        timestamp: Date.now(),
        ...additionalData
      };
      
      // Add to beginning of array (most recent first)
      history.unshift(navigationEntry);
      
      // Keep only the last MAX_HISTORY_LENGTH entries
      if (history.length > MAX_HISTORY_LENGTH) {
        history.splice(MAX_HISTORY_LENGTH);
      }
      
      localStorage.setItem('navigationHistory', JSON.stringify(history));
    } catch (error) {
      console.error('Error saving navigation history:', error);
    }
  },

  // Get navigation history
  getNavigationHistory() {
    try {
      return JSON.parse(localStorage.getItem('navigationHistory') || '[]');
    } catch (error) {
      console.error('Error reading navigation history:', error);
      return [];
    }
  },

  // Get the last navigation entry
  getLastNavigation() {
    const history = this.getNavigationHistory();
    return history.length > 0 ? history[0] : null;
  },

  // Clear navigation history
  clearHistory() {
    try {
      localStorage.removeItem('navigationHistory');
    } catch (error) {
      console.error('Error clearing navigation history:', error);
    }
  },

  // Track navigation from gift cards listing
  trackFromGiftCards(category = null) {
    this.addNavigation('gift-cards', { category });
  },

  // Track navigation from business profile
  trackFromBusinessProfile(businessId, businessName) {
    this.addNavigation('business-profile', { businessId, businessName });
  },

  // Track navigation from search
  trackFromSearch(query) {
    this.addNavigation('search', { query });
  },

  // Track navigation from incentives
  trackFromIncentives() {
    this.addNavigation('incentives');
  },

  // Track navigation from cart
  trackFromCart() {
    this.addNavigation('cart');
  },

  // Track navigation from checkout
  trackFromCheckout() {
    this.addNavigation('checkout');
  },

  // Track navigation from related/sponsored deals
  trackFromRelatedDeals() {
    this.addNavigation('related-deals');
  },

  // Track navigation from home page
  trackFromHome() {
    this.addNavigation('home');
  },
  
  // Track navigation from account pages
  trackFromAccount() {
    this.addNavigation('account');
  }
};

export default NavigationTracker; 